import { SelectionOptionsType } from '@/common/types/SelectionOptions.type';

export enum PropertyInsuranceEnum {
  damaged = 'damaged',
  culprit = 'culprit',
}

export type PropertyInsuranceResponseType = Partial<{
  id: string | null;
  insurance: {
    id: number | null;
    name: string | null;
    code: string | null;
  };
  insurance_number: string | null;
  insurance_start_date: number | null;
  insurance_expiry_date: number | null;
  insurance_expiry_date_last_year: number | null;
  insurance_payment_by: { const: number; fa_const: string } | null;
  insurance_coupon_number: string | null;
  insurance_property_commitment_max: number | null;
  insurance_injury_commitment_max: number | null;
  insurance_passenger_commitment_max: number | null;
}>;

export type PatchPropertyInsuranceParamsType = Partial<{
  insurance_number: string | null;
  insurance: number | null;
  insurance_start_date: string | null;
  insurance_expiry_date: string | null;
  insurance_expiry_date_last_year: string | null;
  insurance_payment_by: number | null;
  insurance_coupon_number: string | null;
  insurance_property_commitment_max: number | null;
  insurance_injury_commitment_max: number | null;
  insurance_passenger_commitment_max: number | null;
}>;

export type PropertyInsuranceFormType = Partial<{
  insurance: SelectionOptionsType<string | number>;
  insurance_number: string | null;
  insurance_start_date: string | null;
  insurance_expiry_date: string | null;
  insurance_expiry_date_last_year: string | null;
  insurance_payment_by: SelectionOptionsType<number> | null;
  insurance_coupon_number: string | null;
  insurance_property_commitment_max: number | null;
  insurance_injury_commitment_max: number | null;
  insurance_passenger_commitment_max: number | null;
}>;
